import { PaginationSettings } from "@/Common/Models/PaginationSettings";
import { PayableInboxSortOrderType, PayableInboxValidity } from "@/Common/Models/UI/Enums";

class PayableInboxFilterSettings {
    public SearchText: string = null;
    public CliniciansProviderSearch: string = null;
    public CliniciansBilledBySearch: string = null;

    public CreationDateFrom: Date = null;
    public CreationDateTo: Date = null;

    public VisitDateFrom: Date = null;
    public VisitDateTo: Date = null;

    public SiteIds: string[] = [];
    public CliniciansProviderContactFacetIds: string[] = [];
    public CliniciansBilledByContactFacetIds: string[] = [];
    public ValidityEnums: PayableInboxValidity[] = [];

    public Pagination: PaginationSettings<PayableInboxSortOrderType> = new PaginationSettings<PayableInboxSortOrderType>(PayableInboxSortOrderType.BillDate);
}

export { PayableInboxFilterSettings };
